import { createFileRoute } from "@tanstack/react-router";
import Start from "@/features/onboarding/pages/start/Start";

export const Route = createFileRoute("/$locale/$partner/_onboarding/start")({
	component: Start,
});
